import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    inrFormatter,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy,
    tooltip_class
} from '../functions'

export default function (chart, divId, vizName, filterParam, gridflag) {
    // var size = chart.axisFontSize
    var fontSize = 15 + "px"
    // var fontColor = chart.axisFontColor
    var fontColor = "red"
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
   //  var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(response => {
        let data = response.data
        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d => {
            return d.dim1_name
        })
            // .sortKeys(d3.ascending).entries(data) //changes to ascending
            .sortKeys(d3.descending).entries(data) //changes to ascending

        // Add X-axis for date and Y-axis
        var x1Scale = d3.scaleBand().rangeRound([0, chart.width]).domain(data.map((d) => {
            return d.dim2_name
        }))
        var y1Scale = d3.scaleLinear().domain([0, d3.max(data, d => {
            return d.metric1
        })]).range([chart.height, 0])

        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1Scale).tickValues(x1Scale.domain().filter(function (d, i) {
                return chart.vizSpecific4 == 'continous' ? !(i % 3) : !(i % 1)
            })))
            //.call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.10em')
            //.attr('transform', 'rotate(-60)')
            .attr('transform', 'rotate(-90)') //change
            .style('fill', 'brown') //change x1scale value color will changed

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom - 5 - chart.axisLabelDistance)
            .style('fill', fontColor)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            // .attr('y', 0 - chart.margin.left)
            .attr('y', 0 - chart.margin.right) //change  in Revenue
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            // .style('fill', fontColor)
            .style('fill', 'green') //change in revenue color
            .text(chart.y1AxisDisplayName)
           .style('font-size', fontSize)
            // .style('font-size', 450) //change

        svg.append('g')
            .call(d3.axisLeft(y1Scale).tickFormat(inrFormatter))
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style("fill","brown") //change in yscale value color

        // if (gridflag == true) {
        if (gridflag == false) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

        // color palette
        var res = sumstat.map(d => {
            return d.key
        }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)

        // Draw the line
        svg.selectAll('.line')
            .data(sumstat)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })
            .attr('stroke-width', 3)
            // .attr('stroke-width', 0) //change to disable line in graph
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => {
                        return x1Scale(d.dim2_name)
                    })
                    .y(d => {
                        return y1Scale(+d.metric1)
                    })

                return line(d.values)
            })
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding


        // Add the dots for the tooltip
        d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip' + divId.id)
            .html((d) => {
                return chart.x1MetricTooltip + colonAnnotation + d.dim2_name + "<br/>" + chart.x2MetricTooltip
                    + colonAnnotation + d.dim1_name + "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric1)
            })

        svg.call(y1tip);

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            // .attr("r", 5)
            .attr("r", 8) // changes in dot radius
            .attr("cx", function (d) {
                return x1Scale(d.dim2_name);
            })
            .attr("cy", function (d) {
                return y1Scale(d.metric1);
            })
            .style("fill", d => {
                return metric1ColorScale(d.dim1_name)
            })
            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
            .on("mouseover", y1tip.show)
            .on("mouseout", y1tip.hide)


        var y1legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            //  .attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {
                //  var height = 0;  // NEW
                var horz = 180 * i; // NEW
                var vert = 6;   // NEW
                return 'translate(' + horz + ',' + vert + ')';   // NEW
            });

        y1legend.append('rect')
            .attr('x', 10)
            .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('width', 35)
            .attr('height', 35)
            .attr('fill', d => {
                return metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(sumstat, (d) => {
                return d.key
            })

            // .attr('x', 40)
            // .attr('y', chart.height + chart.margin.bottom - 60)
            .attr('x', 50) //change in bottom [home app~ ,Health&~..]
            .attr('y', chart.height + chart.margin.bottom - 40) //change in bottom [home app~ ,Health&~..]
            .attr('dy', '0.35em')
            .text((d) => {
                return d.key.length > 7 ? d.key.substring(0, 7) + "~ " : d.key
            })
            .style('font-size', '25px')
    })
}
